/**
 * Tracks where the user was before entering the POS V2 order workspace so its
 * back button can return there (e.g. a table page). Module-scoped: survives
 * in-app navigation and intentionally resets on reload — the workspace then
 * derives a sensible "up" target from the active tab instead.
 */
let orderWorkspaceOrigin: string | null = null;

export function usePosNavigation() {
  function rememberOrderWorkspaceOrigin(fullPath: string): void {
    // Never record the workspace itself (tab switches, query rewrites).
    if (fullPath.includes('/pos/order')) return;
    orderWorkspaceOrigin = fullPath;
  }

  function getOrderWorkspaceOrigin(): string | null {
    return orderWorkspaceOrigin;
  }

  return { rememberOrderWorkspaceOrigin, getOrderWorkspaceOrigin };
}
